jQuery(document).ready(function($) {

    isSmallMobile = {
        any: function() {
            return $(window).width() < 767;
        }
    };



    // Place Homepage only Javascript inside of IF statement
    if (document.body.classList.contains('home')) {
        var header_slider = new Swiper('.headerScroller .swiper-container', {
			speed: 300,
            slidesPerGroup: 1,
            slidesPerView: 8,
            centerInsufficientSlides: true,
			preloadImages: false,
            autoplay: {
                delay: 2500
            },
            loop: true,
			navigation: {
				nextEl: '.headerScroller .swiper-button-next.header',
				prevEl: '.headerScroller .swiper-button-prev.header'
			},
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 3,
                },
                // when window width is >= 767px
                767: {
                    slidesPerView: 4,
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 6,
                },
            }
		});
    }

});